import { action, makeObservable, observable, reaction } from 'mobx';

import { userInfoStore } from '../../../store/userInfoStore';
import { towerGameService } from '../towerService/gameService';
import { freeBetStore } from '../../../store/freeBetStore';

class TowerBetStore {
  towerMatrixSizeVertical = 6;

  towerMatrixSizeHorizontal = 3;

  towerOddsBySize = null;

  selectedIndexes = null;

  selectedStep = null;

  steps = null;

  roundResult = null;

  time = null;

  decisionDuration = null;

  isDoSpinStart = false;

  cashOutWin = null;

  isAllowCashOut = false;

  winAmount = null;

  winOdd = null;

  isLose = false;

  isAllowSendResultReport = false;

  constructor() {
    makeObservable(this, {
      towerMatrixSizeVertical: observable,
      towerMatrixSizeHorizontal: observable,
      towerOddsBySize: observable,
      selectedIndexes: observable,
      selectedStep: observable,
      steps: observable,
      winOdd: observable,
      isLose: observable,
      time: observable,
      roundResult: observable,
      decisionDuration: observable,
      winAmount: observable,
      cashOutWin: observable,
      isDoSpinStart: observable,
      isAllowCashOut: observable,
      isAllowSendResultReport: observable,
      setTowerMatrixSizeVertical: action.bound,
      setTowerMatrixSizeHorizontal: action.bound,
      setTowerOddsBySize: action.bound,
      setSelectedIndexes: action.bound,
      setSelectedStep: action.bound,
      setSteps: action.bound,
      setIsLose: action.bound,
      setTime: action.bound,
      resetTime: action.bound,
      setRoundResult: action.bound,
      setDecisionDuration: action.bound,
      setWinOdd: action.bound,
      setWinAmount: action.bound,
      setCashOutWin: action.bound,
      setIsDoSpinStart: action.bound,
      setIsAllowCashOut: action.bound,
      setIsAllowSendResultReport: action.bound,
    });
    reaction(
      () => this.isDoSpinStart,
      (value) => {
        const { setIsAllowedChangeCurrency } = userInfoStore;
        setIsAllowedChangeCurrency(!value);
        if (freeBetStore.currentFreeBet && !freeBetStore.currentFreeBet.remainingCount && !value) {
          freeBetStore.setIsShowFreeBetPopup(true);
        }
      }
    );
  }

  setTowerMatrixSizeVertical(size) {
    this.towerMatrixSizeVertical = size;
  }

  setTowerMatrixSizeHorizontal(size) {
    this.towerMatrixSizeHorizontal = size;
  }

  setTowerOddsBySize(odds) {
    this.towerOddsBySize = odds;
  }

  setSelectedIndexes(indexes) {
    this.selectedIndexes = indexes;
  }

  setSelectedStep(step) {
    this.selectedStep = step;
  }

  setSteps(steps) {
    this.steps = steps;
  }

  setRoundResult(result) {
    this.roundResult = result;
  }

  setTime(time) {
    this.time = time;
    if (!+time) {
      towerGameService.sendWorker(null);
      towerGameService.sendCashOut();
    }
  }

  resetTime() {
    this.time = null;
  }

  setDecisionDuration(sec) {
    this.decisionDuration = sec;
  }

  setIsAllowSendResultReport(bool) {
    this.isAllowSendResultReport = bool;
  }

  setIsLose(bool) {
    this.isLose = bool;
  }

  setWinOdd(winOdd) {
    this.winOdd = winOdd;
  }

  setWinAmount(winAmount) {
    this.winAmount = winAmount;
  }

  setIsAllowCashOut(bool) {
    this.isAllowCashOut = bool;
  }

  setCashOutWin(cashOutWin) {
    this.cashOutWin = cashOutWin;
  }

  setIsDoSpinStart(bool) {
    this.isDoSpinStart = bool;
  }

  resetStore() {
    this.steps = null;
    this.cashOutWin = null;
    this.selectedStep = null;
    this.isDoSpinStart = false;
    this.isAllowCashOut = false;
    this.roundResult = null;
    this.winAmount = null;
    this.winOdd = null;
    this.isLose = false;
    this.isAllowSendResultReport = false;
  }
}

export const towerBetStore = new TowerBetStore();
